(() => {
  'use strict';
  const config = document.getElementById('beocca-review-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  let scheduled = false;
  function translate() {
    scheduled = false;
    document.querySelectorAll('.jdgm-widget [aria-label]').forEach(element => {
      const original = element.getAttribute('aria-label');
      let translated;
      const rating = original.match(/^(\d+(?:\.\d+)?) out of (\d+) stars$/);
      const page = original.match(/^Go to page (\d+)$/);
      if (rating) translated = labels.rating.replace('__rating__', rating[1]).replace('__max__', rating[2]);
      else if (page) translated = labels.page.replace('__index__', page[1]);
      else translated = ({ 'Pagination Navigation': labels.pagination, 'Go to previous page': labels.previous, 'Go to next page': labels.next, 'Sort reviews by': labels.sort })[original];
      if (translated && translated !== original) element.setAttribute('aria-label', translated);
    });
    document.querySelectorAll('.jdgm-widget label').forEach(label => {
      if (label.textContent.trim() === 'Sort reviews by' && label.textContent !== labels.sort) label.textContent = labels.sort;
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(translate); }
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
  translate();
})();
